import axios from "axios";
import { notification } from "antd";
import { CloudDownloadOutlined } from "@ant-design/icons";

export const BASE_URL = "http://137.184.152.245:8002/api/";
//export const BASE_URL = "http://localhost:8000/api/";

export const Axios = axios.create({
  baseURL: BASE_URL,
});

// Response interceptor for global error handling
Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    if (response) {
      // Server responded with a status code out of the 2xx range
      if (response.status === 401) {
        // Unauthorized - maybe clear token and redirect to login
        localStorage.removeItem("token");
        notification.error({
          message: "Sesión expirada",
          description: "Por favor, inicia sesión nuevamente.",
        });
      } else if (response.status >= 500) {
        notification.error({
          message: "Error del servidor",
          description: "Hubo un problema en el servidor. Inténtalo más tarde.",
        });
      } else {
        // Handle other errors (400, 403, 404, etc.)
        const errorMsg =
          response.data?.detail ||
          response.data?.message ||
          "Ocurrió un error inesperado.";
        notification.error({
          message: "Error",
          description: errorMsg,
        });
      }
    } else if (error.request) {
      // Request was made but no response received
      notification.error({
        message: "Error de red",
        description: "No se pudo establecer conexión con el servidor.",
      });
    } else {
      // Something happened in setting up the request
      console.error("Axios Error:", error.message);
    }

    return Promise.reject(error);
  },
);

export const POST_LOGIN = async (endpoint, data) => {
  const request = await Axios.post(endpoint, data);
  return request;
};

export const POST = async (endpoint, data) => {
  const token = JSON.parse(localStorage.getItem("token"));

  const options = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  const request = await Axios.post(endpoint, data, options);
  return request;
};

export const PATCH = async (endpoint, data) => {
  const token = JSON.parse(localStorage.getItem("token"));

  const options = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  const request = await Axios.patch(endpoint, data, options);
  return request;
};

export const GET = async (endpoint) => {
  const token = JSON.parse(localStorage.getItem("token"));

  const options = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const request = await Axios.get(endpoint, options);
  return request;
};

export const DELETE = async (endpoint) => {
  const token = JSON.parse(localStorage.getItem("token"));

  const options = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const request = await Axios.delete(endpoint, options);
  return request;
};

export const DOWNLOAD = async (endpoint, name_file) => {
  const token = JSON.parse(localStorage.getItem("token"));
  const download = {
    responseType: "blob",
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  const request = await Axios.get(endpoint, download).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", name_file);
    document.body.appendChild(link);
    link.click();
  });

  notification.open({
    message: `${name_file}`,
    description: `Archivo descargado exitosamente!`,
    placement: "topRight",
    icon: <CloudDownloadOutlined style={{ color: "#69802A" }} />,
  });

  return request;
};
